var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "ratings" }, [
    _c("div", { staticClass: "ratings__content" }, [
      _c("div", { staticClass: "title" }, [_vm._v("12 450+")]),
      _vm._v(" "),
      _c("div", { staticClass: "caption" }, [
        _vm._v(_vm._s(_vm.$t("subscriptions.ratings.caption")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "store-container-wrapper" }, [
        _c("div", { staticClass: "store-container" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("\n            4,90"),
              _c("img", {
                staticClass: "icon",
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/app-store.png" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stars" }, [
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [_vm._v("App Store")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("\n            4,85"),
              _c("img", {
                staticClass: "icon",
                attrs: {
                  src: _vm.mediaBaseUrl + "subscriptions/play-store.png"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stars" }, [
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.mediaBaseUrl + "subscriptions/star.svg" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [_vm._v("Play Store")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "branches-container" }, [
          _c("div", { staticClass: "image" }, [
            _c("img", {
              attrs: { src: _vm.mediaBaseUrl + "subscriptions/branches.png" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _c("span", { staticClass: "bold" }, [
              _vm._v(_vm._s(_vm.$t("subscriptions.ratings.bold")))
            ]),
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("subscriptions.ratings.text")) +
                "\n        "
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }